module.exports = __webpack_public_path__ + "img/externe-schulungen-poster.dfac6bdd.png";